<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer" @click="flag=false;flag2=false" class="headPM">模板消息推送</p>
    <p style="font-size: 20px;display: inline-block" v-show="flag||flag2">&emsp;<Icon type="ios-arrow-forward" />&emsp;模板消息使用</p>
    <Tabs value="qiming" style="margin-top: 2%" @on-click="flag=false;flag2=false">
      <TabPane label="启明瞳服务号模板" name="qiming">
        <div v-show="!flag">
          <Table stripe :columns="columns"
                 :data="template_list"
                 @on-expand="expanding"></Table>
        </div>
        <div v-show="flag"><!--模板使用-->
          <Card style="margin: 2% 0;font-size: 16px;border-radius: 20px;width: 95%;"><!--消息模板示例-->
            <Row :gutter="32">
              <Col span="8">
              <div style="border: 1px solid #CCCCCC;border-radius: 10px">
                <ul style="padding: 3% 5%">
                  <li style="padding-top: 2%" v-for="(value,key) in example" :key="key">{{value}}</li>
                </ul>
                <hr style="border: 1px solid #CCCCCC">
                <Row style="padding:  2% 5%;font-size: 18px;color: #CCCCCC;">
                  <Col span="4">详情</Col>
                  <Col span="2" offset="18"><Icon type="ios-arrow-forward" /></Col>
                </Row>
              </div>
              </Col>
              <Col span="16">
              <Row>
                <p style="font-size: 20px">模板消息数据配置</p>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="5"><p>模板ID:</p></Col>
                <Col span="15"><p>{{sendData.templateMsgBody.template_id}}</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="5"><p>标题:</p></Col>
                <Col span="150"><p>{{title}}</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="5"><p>行业:</p></Col>
                <Col span="15">{{industry}}</Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="5"><p id="inputSee">小程序appid:</p></Col>
                <Col span="15">
                <Select v-model="appid1" style="width: 150px;" @on-change="setAppid">
                <Option value="wxce8e592adfc78ceb">启明瞳小程序</Option>
                <Option value="wxe8861b848e9ce4ca">我能帮帮忙小程序</Option>
                </Select>
                </Col>
              </Row>
              <Row>
                <Col span="6"><p style="font-size: 20px;margin-top:1%">详细内容:</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>跳转URL:</p></Col>
                <Col span="15"><Input v-model="skipUrl" placeholder="请输入..."></Input></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>小程序页面路径:</p></Col>
                <Col span="15"><Input v-model="pagepath" placeholder="请输入..." ref="inputVal"></Input></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>主题:</p></Col>
                <Col span="15"><Input v-model="keywords[0]" placeholder="请输入..."></Input></Col>
              </Row>
              <ul>
                <li v-for="(value,key) in content" v-show="key!==0&&key!==content.length-1">
                  <Row  style="margin: 2% 5%">
                    <Col span="6" >{{value}}</Col>
                    <Col span="15"><Input v-model="keywords[key]" placeholder="请输入..."></Input></Col>
                  </Row>
                </li>
              </ul>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>标记:</p></Col>
                <Col span="15"><Input v-model="keywords[content.length-1]" placeholder="请输入..."></Input></Col>
              </Row>
              </Col>
            </Row>
            <Row>
              <p style="font-size: 20px;margin: 2% 2%">群发模板消息：</p>
            </Row>
            <Row>
              <hr style="border:1px solid #CCCCCC;">
            </Row>
            <Row>
              <Row style="margin: 4% 5%">
                <Col span="2">性别</Col>
                <Col span="5">
                <Select v-model="selectSex" style="width: 150px;" @on-change="selectPeople(appids[1])">
                  <Option value="1">男</Option>
                  <Option value="2">女</Option>
                  <Option value="0">未知</Option>
                </Select>
                </Col>
                <Col span="2" offset="1">昵称</Col>
                <Col span="5">
                <Input v-model="nickname" style="width: 150px" @on-change="selectPeople(appids[1])" placeholder="选填"></Input>
                </Col>
                <Col span="3"><p>已选中人数:</p></Col>
                <Col span="3"><p style="color: dodgerblue;">{{number}}</p></Col>
              </Row>
              <Row style="margin: 4% 5%">
                <Col span="2">省份</Col>
                <Col span="18">
                <Checkbox class="provenceS" @on-change="totalProvince">全选</Checkbox>
                <CheckboxGroup v-model="selectProvince" @on-change="selectPeople(appids[1])">
                  <Checkbox label="北京" class="provenceS">北京</Checkbox>
                  <Checkbox label="上海" class="provenceS">上海</Checkbox>
                  <Checkbox label="重庆" class="provenceS">重庆</Checkbox>
                  <Checkbox label="深圳" class="provenceS">深圳</Checkbox>
                  <Checkbox label="天津" class="provenceS">天津</Checkbox>
                  <Checkbox label="南京" class="provenceS">南京</Checkbox>
                  <Checkbox label="湖北" class="provenceS">湖北</Checkbox>
                  <Checkbox label="湖南" class="provenceS">湖南</Checkbox>
                  <Checkbox label="河北" class="provenceS">河北</Checkbox>
                  <Checkbox label="河南" class="provenceS">河南</Checkbox>
                  <Checkbox label="江苏" class="provenceS">江苏</Checkbox>
                  <Checkbox label="浙江" class="provenceS">浙江</Checkbox>
                  <Checkbox label="山西" class="provenceS">山西</Checkbox>
                  <Checkbox label="辽宁" class="provenceS">辽宁</Checkbox>
                  <Checkbox label="吉林" class="provenceS">吉林</Checkbox>
                  <Checkbox label="福建" class="provenceS">福建</Checkbox>
                  <Checkbox label="广东" class="provenceS">广东</Checkbox>
                  <Checkbox label="山东" class="provenceS">山东</Checkbox>
                  <Checkbox label="江西" class="provenceS">江西</Checkbox>
                  <Checkbox label="四川" class="provenceS">四川</Checkbox>
                  <Checkbox label="陕西" class="provenceS">陕西</Checkbox>
                  <Checkbox label="云南" class="provenceS">云南</Checkbox>
                  <Checkbox label="广西" class="provenceS">广西</Checkbox>
                  <Checkbox label="安徽" class="provenceS">安徽</Checkbox>
                  <Checkbox label="宁夏" class="provenceS">宁夏</Checkbox>
                  <Checkbox label="青海" class="provenceS">青海</Checkbox>
                  <Checkbox label="西藏" class="provenceS">西藏</Checkbox>
                  <Checkbox label="甘肃" class="provenceS">甘肃</Checkbox>
                  <Checkbox label="新疆" class="provenceS">新疆</Checkbox>
                  <Checkbox label="黑龙江" class="provenceS">黑龙江</Checkbox>
                  <Checkbox label="内蒙古" class="provenceS">内蒙古</Checkbox>
                  <Checkbox label="香港" class="provenceS">香港</Checkbox>
                  <Checkbox label="澳门" class="provenceS">澳门</Checkbox>
                  <Checkbox label="台湾" class="provenceS">台湾</Checkbox>
                  <Checkbox label="海外" class="provenceS">海外</Checkbox>
                </CheckboxGroup>
                </Col>
              </Row>
              <Row  style="text-align: center;margin: 6% 2% 5% 2%;">
                <Col span="6"><Button type="success" @click.native="immedeSend(content)">立即发送</Button></Col>
                <Col span="12">
                定时：
                <Input type="text" v-model="timeSetting" @on-change="getSetTime" style="width: 100px;"></Input>
                <Select v-model="timeDanwei" style="width: 100px;" @on-change="getSetTime">
                  <Option value="1">秒</Option>
                  <Option value="60">分钟</Option>
                  <Option value="3600">小时</Option>
                </Select>

                </Col>
                <Col span="6"><Button type="success" @click.native="timedSend(content)">定时发送</Button></Col>
              </Row>
            </Row>
          </Card>
        </div>
      </TabPane>
      <TabPane label="我能帮帮忙服务号模板" name="help">
        <div v-show="!flag2">
          <Table stripe :columns="columns2"
                 :data="template_list2"
                 @on-expand="expanding"></Table>
        </div>
        <div v-show="flag2"><!--模板使用-->
          <Card style="margin: 2% 0;font-size: 16px;border-radius: 20px;width: 95%;"><!--消息模板示例-->
            <Row :gutter="16">
              <Col span="8">
              <div style="border: 1px solid #CCCCCC;border-radius: 10px">
                <ul style="padding: 3% 5%">
                  <li style="padding-top: 2%" v-for="(value,key) in example2" :key="key">{{value}}</li>
                </ul>
                <hr style="border: 1px solid #CCCCCC">
                <Row style="padding:  2% 5%;font-size: 18px;color: #CCCCCC;">
                  <Col span="4">详情</Col>
                  <Col span="2" offset="18"><Icon type="ios-arrow-forward" /></Col>
                </Row>
              </div>
              </Col>
              <Col span="16">
              <Row>
                <p style="font-size: 20px">模板消息数据配置</p>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>模板ID:</p></Col>
                <Col span="15"><p>{{sendData.templateMsgBody.template_id}}</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>标题:</p></Col>
                <Col span="150"><p>{{title}}</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>行业:</p></Col>
                <Col span="15">{{industry}}</Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p  id="inputSee2">小程序appid:</p></Col>
                <Col span="15">
                <Select v-model="appid1" style="width: 150px;" @on-change="setAppid">
                  <Option value="wxce8e592adfc78ceb">启明瞳小程序</Option>
                  <Option value="wxe8861b848e9ce4ca">我能帮帮忙小程序</Option>
                </Select>
                </Col>
              </Row>
              <Row>
                <Col span="6"><p style="font-size: 20px;margin-top:1%">详细内容:</p></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>跳转URL:</p></Col>
                <Col span="15"><Input v-model="skipUrl" placeholder="请输入..."></Input></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>小程序页面路径:</p></Col>
                <Col span="15"><Input v-model="pagepath" placeholder="请输入..." ref="inputVal"></Input></Col>
              </Row>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>主题:</p></Col>
                <Col span="15"><Input v-model="keywords[0]" placeholder="请输入..."></Input></Col>
              </Row>
              <ul>
                <li v-for="(value,key) in content2" v-show="key!==0&&key!==content2.length-1">
                  <Row  style="margin: 2% 5%">
                    <Col span="6" >{{value}}</Col>
                    <Col span="15"><Input v-model="keywords[key]" placeholder="请输入..."></Input></Col>
                  </Row>
                </li>
              </ul>
              <Row style="margin: 1% 5%">
                <Col span="6"><p>标记:</p></Col>
                <Col span="15"><Input v-model="keywords[content2.length-1]" placeholder="请输入..."></Input></Col>
              </Row>
              </Col>
            </Row>
            <Row>
              <p style="font-size: 20px;margin: 2% 2%">群发模板消息：</p>
            </Row>
            <Row>
              <hr style="border:1px solid #CCCCCC;">
            </Row>
            <Row>
              <Row style="margin: 4% 5%">
                <Col span="2">性别</Col>
                <Col span="5">
                <Select v-model="selectSex" style="width: 150px;" @on-change="selectPeople(appids[2])">
                  <Option value="1">男</Option>
                  <Option value="2">女</Option>
                  <Option value="0">未知</Option>
                </Select>
                </Col>
                <Col span="2" offset="1">昵称</Col>
                <Col span="5">
                <Input v-model="nickname" style="width: 150px" @on-change="selectPeople(appids[2])" placeholder="选填"></Input>
                </Col>
                <Col span="3"><p>已选中人数:</p></Col>
                <Col span="3"><p style="color: dodgerblue;">{{number}}</p></Col>
              </Row>
              <Row style="margin: 4% 5%">
                <Col span="2">省份</Col>
                <Col span="18">
                <Checkbox class="provenceS" @on-change="totalProvince">全选</Checkbox>
                <CheckboxGroup v-model="selectProvince" @on-change="selectPeople(appids[2])">
                  <Checkbox label="北京" class="provenceS">北京</Checkbox>
                  <Checkbox label="上海" class="provenceS">上海</Checkbox>
                  <Checkbox label="重庆" class="provenceS">重庆</Checkbox>
                  <Checkbox label="深圳" class="provenceS">深圳</Checkbox>
                  <Checkbox label="天津" class="provenceS">天津</Checkbox>
                  <Checkbox label="南京" class="provenceS">南京</Checkbox>
                  <Checkbox label="湖北" class="provenceS">湖北</Checkbox>
                  <Checkbox label="湖南" class="provenceS">湖南</Checkbox>
                  <Checkbox label="河北" class="provenceS">河北</Checkbox>
                  <Checkbox label="河南" class="provenceS">河南</Checkbox>
                  <Checkbox label="江苏" class="provenceS">江苏</Checkbox>
                  <Checkbox label="浙江" class="provenceS">浙江</Checkbox>
                  <Checkbox label="山西" class="provenceS">山西</Checkbox>
                  <Checkbox label="辽宁" class="provenceS">辽宁</Checkbox>
                  <Checkbox label="吉林" class="provenceS">吉林</Checkbox>
                  <Checkbox label="福建" class="provenceS">福建</Checkbox>
                  <Checkbox label="广东" class="provenceS">广东</Checkbox>
                  <Checkbox label="山东" class="provenceS">山东</Checkbox>
                  <Checkbox label="江西" class="provenceS">江西</Checkbox>
                  <Checkbox label="四川" class="provenceS">四川</Checkbox>
                  <Checkbox label="陕西" class="provenceS">陕西</Checkbox>
                  <Checkbox label="云南" class="provenceS">云南</Checkbox>
                  <Checkbox label="广西" class="provenceS">广西</Checkbox>
                  <Checkbox label="安徽" class="provenceS">安徽</Checkbox>
                  <Checkbox label="宁夏" class="provenceS">宁夏</Checkbox>
                  <Checkbox label="青海" class="provenceS">青海</Checkbox>
                  <Checkbox label="西藏" class="provenceS">西藏</Checkbox>
                  <Checkbox label="甘肃" class="provenceS">甘肃</Checkbox>
                  <Checkbox label="新疆" class="provenceS">新疆</Checkbox>
                  <Checkbox label="黑龙江" class="provenceS">黑龙江</Checkbox>
                  <Checkbox label="内蒙古" class="provenceS">内蒙古</Checkbox>
                  <Checkbox label="香港" class="provenceS">香港</Checkbox>
                  <Checkbox label="澳门" class="provenceS">澳门</Checkbox>
                  <Checkbox label="台湾" class="provenceS">台湾</Checkbox>
                  <Checkbox label="海外" class="provenceS">海外</Checkbox>
                </CheckboxGroup>
                </Col>
              </Row>
              <Row  style="text-align: center;margin: 6% 2% 5% 2%;">
                <Col span="12"><Button type="success" @click.native="immedeSend2(content2)">立即发送</Button></Col>
                <Col span="12"><Button type="success" @click.native="timeSend2(content2)">定时发送</Button></Col>
              </Row>
            </Row>
          </Card>
        </div>
      </TabPane>
    </Tabs>
    <Modal
      v-model="modalShow"
      title="注意！">
      <h3>在选择了小程序appid的情况下，小程序页面路径不可为空！</h3>
      <div slot="footer"><Button type="primary" @click.native="makeSure">确认</Button></div>
    </Modal>

  </div>
</template>

<script>
  import expandRow from './expandRow.vue';
  export default {
    name: "templateMessage",
    components: { expandRow },
    data() {
      return {
        appids:["wxcba996672c60318c", "wxa4137801758c1854", "wxcf77238b2c0d9de3"], //0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号
        title:"", //标题
        industry:"", //行业
        skipUrl:"", //跳转url
        appid:"", //小程序appid
        pagepath:"", //小程序页面路径
        selectSex:0, //按性别选择用户的openid
        selectProvince:[], //按省份选择用户openid
        totalFlag:true, //是否选择全部用户
        nickname:"", //按昵称选择用户openid
        timeDanwei:1, //选择时间的单位
        timeSetting:0, //设定的时间
        modalShow:false, //模态框显示
        peopleReturn:{
          "appid": "",
          "nickname": "",
          "sex": 0,
          "provinces":[]//用户所在省
        }, //返回后台的数据
        number:0, //群发的人数
        sendPeople:[], //发消息的对象的openid
        totalPeople:[], //获取到的要发消息的所有人
        keywords:["", "", "", "", "", "", "", ""], //发送的部分消息
        accessToken:["", "", ""], //0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号
        appid1:"",
        sendData:{
          "openids":[], //sendPeople取其每个人的openid
          "accessToken":"", //accessToken
          "templateMsgBody":{
            "template_id":"", //点击使用模板的时候自动填写
            "touser":"",
            "url":"https://www.bemyeyes.com.cn/notify/",
            // "miniprogram": {//之后动态添加
            //   "appid": "", //选择appid时自动填写
            //   "pagepath": ""
            // },
            "data":{
              "first": {
                "value":"",
                "color":"#000"
              },
              "keyword1":{
                "value":"",
                "color":"#000"
              },
              "keyword2": {
                "value":"",
                "color":"#000"
              },
              "keyword3": {
                "value":"",
                "color":"#000"
              },
              // "keyword4": {
              //   "value":"2014年9月22日",
              //   "color":"#000"
              // },
              "remark":{
                "value":"",
                "color":"#000"
              }
            }
          }
        }, //发送的消息

        /*启明瞳服务号*/
        template_list:[], //启明瞳服务号模板列表
        flag:false, //显示页面切换
        example:[], //模板使用时顶部展示
        content:[], //填写需要发送的消息
        columns:[
          {
            title:"序号",
            type:"index",
            key:"index",
            width:60,
            align:"left"
          },
          {
            title:"模板ID",
            key:"template_id",
            width:350,
            align:"left"
          },
          {
            title:"标题",
            key:"title",
            align:"left"
          },
          {
            title:"一级行业",
            key:"primary_industry",
            align:"left"
          },
          {
            title:"二级行业",
            key:"deputy_industry",
            align:"left"
          },
          {
            title:"展开 / 收起",
            type: 'expand',
            width: 100,
            render: (h, params) => {
              return h(expandRow, {
                props: {
                  index:params.index,
                  template_list:this.template_list
                }
              });
            }
          },
          {
            title: "操作",
            align: "center",
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props:{
                    type:"primary"
                  },
                  style:{
                    borderRadius:"20px"
                  },
                  on: {
                    click: () => {
                      let tmp = "";
                      tmp = this.template_list[params.index].example;
                      this.example = tmp.split('\n');
                      tmp = this.template_list[params.index].content.replace(/\{{(.+?)\}}/g, "");
                      this.content = tmp.split('\n');

                      this.title=this.template_list[params.index].title;
                      this.industry=this.template_list[params.index].primary_industry;

                      this.sendData.templateMsgBody.template_id=this.template_list[params.index].template_id;
                      this.flag=!this.flag;
                    }
                  }
                }, "点击使用")
              ]);
            }
          }
        ], //启明瞳服务号模板列表表格列

        /*我能帮帮忙服务号*/
        template_list2:[], //我能帮帮忙服务号模板列表
        flag2:false, //显示页面切换
        example2:[], //页面切换后顶部展示
        content2:[], //填写需要发送的消息
        columns2:[
          {
            title:"序号",
            type:"index",
            key:"index",
            width:60,
            align:"left"
          },
          {
            title:"模板ID",
            key:"template_id",
            width:350,
            align:"left"
          },
          {
            title:"标题",
            key:"title",
            align:"left"
          },
          {
            title:"一级行业",
            key:"primary_industry",
            align:"left"
          },
          {
            title:"二级行业",
            key:"deputy_industry",
            align:"left"
          },
          {
            title:"展开 / 收起",
            type: 'expand',
            width: 100,
            render: (h, params) => {
              return h(expandRow, {
                props: {
                  index:params.index,
                  template_list:this.template_list2
                }
              });
            }
          },
          {
            title: "操作",
            align: "center",
            render: (h, params) => {
                return h('div', [
                  h('Button', {
                    props:{
                      type:"primary"
                    },
                    style:{
                      borderRadius:"20px"
                    },
                    on: {
                      click: () => {
                        let tmp = "";
                        tmp = this.template_list2[params.index].example;
                        this.example2 = tmp.split('\n');
                        tmp = this.template_list2[params.index].content.replace(/\{{(.+?)\}}/g, "");
                        this.content2 = tmp.split('\n');

                        this.title=this.template_list2[params.index].title;
                        this.industry=this.template_list2[params.index].primary_industry;

                        this.sendData.templateMsgBody.template_id=this.template_list2[params.index].template_id;
                        this.flag2=!this.flag2;
                      }
                    }
                  }, "点击使用")
                ]);
            }
          }
        ], //我能帮帮忙服务号模板列表表格列
        clockTime:null
      };
    },
    methods:{
      test(){
        console.log(this.selectProvince);
      },
      makeSure(){
        this.modalShow=false;
        this.$refs.inputVal.focus();
        document.querySelector("#inputSee").scrollIntoView(true);
        document.querySelector("#inputSee2").scrollIntoView(true);
      }, //模块框确认
      setAppid(){
        this.sendData.templateMsgBody.miniprogram={};//动态添加这个属性
        this.sendData.templateMsgBody.miniprogram.appid=this.appid1;
        /*小程序页面路径*/
        this.sendData.templateMsgBody.miniprogram.pagepath=this.pagepath;
      }, //设置要发送的appid
      getSetTime(){
        this.timeSetting=this.timeSetting*this.timeDanwei;
        console.log(this.timeSetting);
      }, //获取定时的时间
      totalProvince(){ //选择全部城市
        if(this.totalFlag){
          this.selectProvince=["北京", "上海", "重庆", "深圳", "天津", "南京",
                                 "湖北", "湖南", "河北", "河南", "江苏", "浙江",
                                 "山西", "辽宁", "吉林", "福建", "广东", "山东",
                                 "江西", "四川", "陕西", "云南", "广西", "安徽",
                                 "宁夏", "青海", "西藏", "甘肃", "新疆", "黑龙江",
                                 "内蒙古", "香港", "澳门", "台湾", "海外"];
          this.totalFlag=false;
        }else{
          this.selectProvince=[];
          this.totalFlag=true;
        }
      },
      expanding(){ //展开详情时触发
      },
      selectPeople(appid){ //已经选择的人数
        this.peopleReturn.appid=appid;
        this.peopleReturn.nickname=this.nickname;
        this.peopleReturn.provinces=this.selectProvince;
        this.peopleReturn.sex=this.selectSex;

        console.log(this.peopleReturn);
        this.$http.post('/zm/backManage/getAccountFollowerInfos', this.peopleReturn).then(res => {
          this.totalPeople=res.data.content;
          this.number=this.totalPeople.length;
        });
      },
      immedeSend(content){ //立即发送
         this.sendData.accessToken=this.accessToken[1];
        if (confirm('请确定是否发送')){
            this.sending(content);
        }
      },
      immedeSend2(content){
        this.sendData.accessToken=this.accessToken[2];
          if (confirm('请确定是否发送')){
              this.sending(content);
          }
      },
      sending(content){
        this.sendData.templateMsgBody.data.first.value=this.keywords[0];
        this.sendData.templateMsgBody.data.keyword1.value=this.keywords[1];
        this.sendData.templateMsgBody.data.keyword2.value=this.keywords[2];
        if(content.length>=5){
          this.sendData.templateMsgBody.data.keyword3.value=this.keywords[3];
        }
        this.sendData.templateMsgBody.data.remark.value=this.keywords[content.length-1];

        /*跳转url*/
        this.sendData.templateMsgBody.url=this.skipUrl;
        /*要发送的openid*/
        let i;
        for(i in this.totalPeople){
          this.sendData.openids.push(this.totalPeople[i].openid);
        }

        //检测小程序appid是否已经选择
        if(this.sendData.templateMsgBody.hasOwnProperty("miniprogram")){ //判断是否有这个属性，有的话表示选择了小程序appid
          this.sendData.templateMsgBody.miniprogram.pagepath=this.pagepath;
          if(this.sendData.templateMsgBody.miniprogram.pagepath==="") { //如果页面路径没有填写
            this.modalShow = true;
            return;
          }
        }

        this.$http.post('/zm/backManage/sendTemplateMsg', this.sendData).then(res => {
            this.sendData.openids = [];
            this.$Message.success(res.content);
        }, err => {
          this.sendData.openids = [];
          this.$Message.error(err.content);
        });
      }, //发送
      timedSend(content){ //定时发送
          if (confirm('请确定是否发送')){
              this.clockTime=setTimeout(() => { this.immedeSend(content); }, this.timeSetting*1000);
          }
      },
      timeSend2(content){

      }
    },
    beforeDestroy(){
      clearInterval(this.clockTime);
    },
    mounted(){
    },
    activated(){
      /*初始化数据*/
      this.flag=false;
      this.flag2=false;
      this.keywords = ["", "", "", "", "", "", ""];

      // let accessToken = ["", "", ""];//0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号

      /*启明瞳服务号:根据appid获取AccessToken*/
      this.$http.get("/zm/backManage/getAccessToken?appid=" + this.appids[1]).then(res => {
        this.accessToken[1] = res.data.content;

        /*根据AccessToken获取列表*/
        this.$http.get("/cgi-bin/template/get_all_private_template?access_token=" + this.accessToken[1])
          .then(res => { //启明瞳服务号
            this.template_list = res.data.template_list;
            this.template_list.splice(0, 1);
          });
      });

      /*我能帮帮忙服务号:根据appid获取AccessToken*/
      this.$http.get("/zm/backManage/getAccessToken?appid=" + this.appids[2]).then(res => {
        this.accessToken[2] = res.data.content;

        /*根据AccessToken获取列表*/
        this.$http.get("/cgi-bin/template/get_all_private_template?access_token=" + this.accessToken[2])
          .then(res => { //我能帮帮忙
            this.template_list2 = res.data.template_list;
            this.template_list2.splice(0, 1);
          });
      });
    }
  };
</script>

<style scoped>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }
  .headPM:hover{
    color:dodgerblue;
  }
  ul{
    list-style-type: none;
  }
  li{
    font-size: 16px;
  }
  .provenceS{
    width:60px;
    margin: 1%;
  }
</style>



// WEBPACK FOOTER //
// templateMessage.vue?7859cbd9